const header = document.querySelector('.swf-header');
const burger = document.querySelector('.swf-header__burger');
const menu = document.getElementById('SwfMobileMenu');

function setHeaderHeight() {
  if (!header) return;
  document.documentElement.style.setProperty('--swf-header-height', header.offsetHeight + 'px');
}

setHeaderHeight();
window.addEventListener('resize', setHeaderHeight);

if (burger && menu && header) {
  function openMenu() {
    document.documentElement.style.setProperty(
      '--swf-mobile-header-height',
      header.offsetHeight + 'px'
    );
    menu.classList.add('swf-mobile-menu--open');
    menu.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Close menu');
    document.body.classList.add('swf-menu-open');
    // Move focus into the menu for keyboard users.
    const firstLink = menu.querySelector('a, button');
    if (firstLink) firstLink.focus();
  }

  function closeMenu({ returnFocus = false } = {}) {
    menu.classList.remove('swf-mobile-menu--open');
    menu.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open menu');
    document.body.classList.remove('swf-menu-open');
    if (returnFocus) burger.focus();
  }

  const isOpen = () => menu.classList.contains('swf-mobile-menu--open');

  burger.addEventListener('click', () => {
    isOpen() ? closeMenu() : openMenu();
  });

  document.addEventListener('click', (e) => {
    if (isOpen() && !menu.contains(e.target) && !burger.contains(e.target)) {
      closeMenu();
    }
  });

  // Escape closes the menu and returns focus to the toggle.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) {
      closeMenu({ returnFocus: true });
    }
  });
}
